import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-xl font-bold text-primary40" }
const _hoisted_2 = { class: "px-5 py-4" }

import Modal from '@/components/designSystem/modals/Modal.vue'
import DsAttendancePolicy from '@/components/ManageScale/Schedule/DsAttendancePolicy.vue'

import type { DSAttendancePolicyData } from '@/types/ds-attendance.types'
import type { CurrentCheckRequirement, ScheduleCheckFlags } from '@/utils/registrationCheck'


export default /*#__PURE__*/_defineComponent({
  __name: 'DSAttendancePolicyModal',
  props: {
    isOpen: { type: Boolean },
    initialData: {},
    title: {},
    availableShifts: {},
    scheduleEndDate: {},
    canEditRegistrationSection: { type: Boolean, default: undefined },
    openActivityRecords: {},
    scheduleId: {},
    inheritedCheckFlags: {},
    currentCheckRequirement: {}
  },
  emits: ["close", "save"],
  setup(__props: any, { emit }) {

const props = __props;





const handleSave = (data: DSAttendancePolicyData) => {
  emit('save', data)
}

const handleCancel = () => {
  emit('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.isOpen,
    "max-width": "max-w-5xl",
    onClose: handleCancel
  }, _createSlots({
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(DsAttendancePolicy, {
          "initial-data": props.initialData,
          "available-shifts": props.availableShifts,
          "schedule-end-date": props.scheduleEndDate,
          "can-edit-registration-section": props.canEditRegistrationSection,
          "open-activity-records": props.openActivityRecords,
          "schedule-id": props.scheduleId,
          "inherited-check-flags": props.inheritedCheckFlags,
          "current-check-requirement": props.currentCheckRequirement,
          onSave: handleSave,
          onCancel: handleCancel,
          fullWidthModal: ""
        }, null, 8, ["initial-data", "available-shifts", "schedule-end-date", "can-edit-registration-section", "open-activity-records", "schedule-id", "inherited-check-flags", "current-check-requirement"])
      ])
    ]),
    _: 2
  }, [
    (_ctx.title)
      ? {
          name: "header",
          fn: _withCtx(() => [
            _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.title), 1)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modal-active"]))
}
}

})